import type { IconName } from "designs/DesignB/components/icons";

/**
 * Design B's Why us draws one line-icon set (1NOW-11175). Tenants' own icon uploads were a
 * mix of clip-art (a yellow taxi, a circuit board, a red cart, a blue "i"), so the icon is
 * picked from the set by what the point says, and by its place in the list when it says none
 * of these.
 */
const BY_WORD: [RegExp, IconName][] = [
  [/insur|cover|protect|safe|secur|trust/, "shield"],
  [/price|rate|cost|cheap|afford|deal|value|offer|discount|fee|save/, "tag"],
  [/locat|pick|deliver|branch|airport|drop|map|where|near/, "pin"],
  [/wedding|event|party|celebrat|occasion|holiday|trip/, "calendar"],
  [/support|help|service|24|concierge|care|team|assist/, "headset"],
  [/flex|hour|time|day|week|length|quick|fast|easy|simple|book|instant|minute/, "clock"],
  [/fleet|car|vehicle|choice|classic|convertible|luxury|select|model|brand/, "car"],
];
const BY_PLACE: IconName[] = ["check", "key", "shield", "tag", "pin", "headset", "clock", "car"];

const plain = (html: unknown) => String(html ?? "").replace(/<[^>]*>/g, " ").toLowerCase();

export const whyIcon = (heading: unknown, index: number): IconName =>
  BY_WORD.find(([word]) => word.test(plain(heading)))?.[1] ?? BY_PLACE[index % BY_PLACE.length];

/**
 * How many columns hold n points with no half-empty row: 4 or 3 when n divides by it, else the
 * number of points up to three (a lone pair or trio fills its row), else three, where the last
 * row is centred rather than left short.
 */
export const whyColumns = (n: number): number => {
  if (n <= 0) return 1;
  if (n <= 3) return n;
  if (n % 4 === 0) return 4;
  if (n % 3 === 0) return 3;
  return 3;
};
